/* K+K Variant Display — generated by K+K Variant Display Builder.
   Shows a color pill over the product image and a swatch strip under the
   variant picker, matching variant titles against the color keywords below.
   Edit KK_VD.keywords / KK_VD.overrides here, or regenerate from
   kk-color-display-builder.html and copy its config over this one. */
(function(){
  var KK_VD = {
    "keywords": {
      "red":    {"name": "Red",    "hex": "#E62128"},
      "blue":   {"name": "Blue",   "hex": "#1E5BC4"},
      "white":  {"name": "White",  "hex": "#FFFFFF"},
      "amber":  {"name": "Amber",  "hex": "#F4A111"},
      "green":  {"name": "Green",  "hex": "#2DA84E"},
      "black":  {"name": "Black",  "hex": "#1A1A1A"},
      "chrome": {"name": "Chrome", "hex": "#C0C0C0"},
      "yellow": {"name": "Yellow", "hex": "#FFD700"},
      "grey":   {"name": "Grey",   "hex": "#B0B0B0"},
      "clear":  {"name": "Clear",  "hex": "#E8F4FB"},
      "smoked": {"name": "Smoked", "hex": "#3A3A3A"}
    },
    "overrides": {},
    /* Option-role classification (matched against the option NAME, lowercase
       contains). Scales across the whole catalog with no per-product setup:
       - colorRoles: option values become the glowing light-color dots
       - chipRoles:  option values become small labeled chips (lens, bezel...)
       - everything else (mounts, brackets, sizes, cables, Optis add-ons) is
         ignored by the display entirely. */
    /* When the selected variant has its own assigned image, the gallery
       shows the right photo. Set showWhenAccurate to false to display the
       pill/swatch ONLY when the photo does NOT match (variant has no image). */
    "showWhenAccurate": true,
    "colorRoles": ["color", "colour", "led"],
    "chipRoles": ["lens", "bezel", "housing", "dome", "finish"],
    /* The pill anchors to the media ITEM being shown (Dawn stacks all images
       in a column, so anchoring to the whole gallery puts the pill at the
       bottom of the LAST image, below the fold). imageSelector is the
       fallback for non-Dawn layouts. */
    "mediaItemSelector": ".product__media-item.is-active, .product__media-item",
    "imageSelector": ".product__media-list, .product__media-wrapper, .product-single__photos, .product__media, .product-single__photo, .product-gallery, .product-photo-container",
    "variantSelector": "[name=\"id\"]"
  };
  var MULTI_BASE = ["red","blue","white","amber","green"];

  function esc(s){ return s.replace(/[&<>"']/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;"}[c];}); }
  function escRe(s){ return s.replace(/[.*+?^${}()|[\]\\]/g,"\\$&"); }
  function getMount(){ return document.getElementById("kk-vd-mount"); }
  function getHandle(){ var m=getMount(); return m?(m.getAttribute("data-kk-product-handle")||""):""; }
  function getVariantId(){
    var inp=document.querySelector(KK_VD.variantSelector);
    if(inp && inp.value) return inp.value;
    var m=getMount(); return m?m.getAttribute("data-kk-variant-id"):null;
  }
  function getData(){
    var el=document.getElementById("kk-vd-variants");
    if(!el) return {optionNames:[],variants:[],tags:[]};
    try { var d=JSON.parse(el.textContent); return {optionNames:d.optionNames||[],variants:d.variants||[],tags:d.tags||[]}; }
    catch(e){ return {optionNames:[],variants:[],tags:[]}; }
  }
  function getVariants(){ return getData().variants; }
  function getCurrentVariant(){
    var vid=getVariantId(), variants=getVariants();
    for (var i=0;i<variants.length;i++) if (String(variants[i].id)===String(vid)) return variants[i];
    /* K&K 2026-10-20: Liquid lists at most 250 variants (DynaFlare has 371).
       For a variant past the cap, build it from the picker's selected values. */
    var names=getData().optionNames||[];
    var opts=names.map(function(n){
      var s=document.querySelector('variant-selects select[name="options['+n+']"]');
      return (s&&s.selectedIndex>=0)?(s.options[s.selectedIndex].text||"").trim():null;
    });
    if(opts.some(function(o){return o!=null;})) return {id:vid,title:opts.filter(Boolean).join(" / "),img:false,mid:null,opts:opts};
    return null;
  }
  function getCurrentTitle(){
    var v=getCurrentVariant(); return v?v.title:"";
  }
  function kkColorSignature(variant, optionNames){
    /* Stable signature of a variant's light colors, for comparing variants. */
    var found=[];
    if(variant && variant.opts && optionNames && optionNames.length){
      optionNames.forEach(function(name, idx){
        if(roleOf(name)!=="color") return;
        var val=variant.opts[idx]; if(val==null) return;
        detectKeywords(val).forEach(function(k){ if(found.indexOf(k)===-1) found.push(k); });
      });
    }
    if(!found.length && variant) found=detectKeywords(variant.title||"");
    return found.sort().join("|");
  }

  function kkImageIsGeneric(cur, data){
    /* The variant has an assigned image — but if another variant with a
       DIFFERENT color set shares the SAME image, that image is a generic
       stand-in, not color-accurate. */
    if(!cur || cur.mid == null) return false;
    var myKey=kkColorSignature(cur, data.optionNames);
    var variants=data.variants||[];
    for(var i=0;i<variants.length;i++){
      var v=variants[i];
      if(String(v.id)===String(cur.id)) continue;
      if(v.mid != null && String(v.mid)===String(cur.mid) && kkColorSignature(v, data.optionNames)!==myKey) return true;
    }
    return false;
  }

  function kkExtractChipPhrases(text){
    /* Inside color-role values and title scans, phrases like "Clear lens",
       "Smoked lens", or "Black bezel" describe a COMPONENT, not a light
       color. Pull them out as chips and return the remaining text so the
       embedded color word can't become a dot. */
    var chips=[], cleaned=String(text||"");
    (KK_VD.chipRoles||[]).forEach(function(role){
      var re=new RegExp("\\b([a-z][a-z-]*)[\\s-]+("+role.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")+")\\b","gi");
      cleaned=cleaned.replace(re, function(m, w){
        var kw=KK_VD.keywords[w.toLowerCase()];
        if(!kw) return m; /* "L-Bracket Mount": unknown word stays put */
        var label=m.replace(/\s+/g," ").trim();
        label=label.charAt(0).toUpperCase()+label.slice(1);
        if(!chips.some(function(c){return c.text.toLowerCase()===label.toLowerCase();}))
          chips.push({text:label, hex:kw.hex});
        return " ";
      });
    });
    return {chips:chips, cleaned:cleaned};
  }

  function roleOf(optionName){
    var n=String(optionName||"").toLowerCase();
    for (var i=0;i<KK_VD.colorRoles.length;i++) if(n.indexOf(KK_VD.colorRoles[i])!==-1) return "color";
    for (var j=0;j<KK_VD.chipRoles.length;j++) if(n.indexOf(KK_VD.chipRoles[j])!==-1) return "chip";
    return "ignore";
  }
  function getFormText(){
    var form=document.querySelector('form[action*="/cart/add"]');
    if(!form) return "";
    var bits=[];
    form.querySelectorAll("select").forEach(function(s){ var o=s.options[s.selectedIndex]; if(o) bits.push(o.text||""); });
    form.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach(function(i){
      var lab=document.querySelector('label[for="'+i.id+'"]');
      if(lab) bits.push(lab.textContent||"");
      else if(i.parentElement) bits.push(i.parentElement.textContent||"");
    });
    return bits.join(" ");
  }
  function detectKeywords(text){
    if(!text) return [];
    var seen={}, out=[];
    Object.keys(KK_VD.keywords).forEach(function(k){
      var re=new RegExp("\\b"+escRe(k)+"\\b","i");
      if(re.test(text)&&!seen[k]){ seen[k]=true; out.push(k); }
    });
    return out;
  }
  function detectMulti(t){ return /multi[\-\s]?colou?r/i.test(t||""); }
  function detectSplit(t){ return /\bsplit\b/i.test(t||""); }
  function isLight(hex){
    var h=(hex||"").replace("#",""); if(h.length===3) h=h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    if(h.length<6) return false;
    var r=parseInt(h.substr(0,2),16),g=parseInt(h.substr(2,2),16),b=parseInt(h.substr(4,2),16);
    return (0.299*r+0.587*g+0.114*b)>165;
  }

  function resolve(){
    var handle=getHandle(), ov=KK_VD.overrides[handle]||null;
    var title=getCurrentTitle()+" "+getFormText();
    var label=(ov && ov.label) || "Your selected colors";
    var isMulti=detectMulti(title), isSplit=detectSplit(title);
    var colors=[], chips=[];
    var data=getData(), cur=getCurrentVariant();
    if(isMulti){
      colors = MULTI_BASE.filter(function(k){ return KK_VD.keywords[k]; });
    } else if(ov && ov.colors && ov.colors.length){
      colors = ov.colors.filter(function(k){ return KK_VD.keywords[k]; });
    } else if(cur && cur.opts && data.optionNames && data.optionNames.length){
      /* Role-based classification: each Shopify option contributes by what
         its NAME says it is, so "Black Bezel" can never read as a light color
         and "L-Bracket Mount" is ignored automatically. */
      var sawColorRole=false;
      data.optionNames.forEach(function(name, idx){
        var value=cur.opts[idx]; if(value==null) return;
        var role=roleOf(name);
        if(role==="color"){
          sawColorRole=true;
          var ex=kkExtractChipPhrases(value);
          ex.chips.forEach(function(ch){
            if(!chips.some(function(c){return c.text.toLowerCase()===ch.text.toLowerCase();})) chips.push(ch);
          });
          detectKeywords(ex.cleaned).forEach(function(k){ if(colors.indexOf(k)===-1) colors.push(k); });
        } else if(role==="chip"){
          var kw=detectKeywords(value)[0]||null;
          chips.push({ text:value, hex: kw?KK_VD.keywords[kw].hex:"#999999" });
        }
      });
      /* Product with no color-named option (e.g. single "Style" option):
         fall back to scanning the full title so it still works. */
      if(!sawColorRole && !colors.length && !chips.length){
        var exf=kkExtractChipPhrases(title);
        chips=exf.chips; colors=detectKeywords(exf.cleaned);
      }
    } else {
      var ext=kkExtractChipPhrases(title);
      chips=ext.chips; colors=detectKeywords(ext.cleaned);
    }
    /* Mismatch decision, in order of precedence:
       1. per-product override  { "forceMismatch": true/false }  — beats all
       2. product tag "kk-photo-differs" (force on) / "kk-photo-ok" (force off)
          — bulk-manageable from Shopify admin for thousands of products
       3. variant has NO image of its own -> photo is a stand-in
       4. variant HAS an image, but the SAME image is shared by variants with
          different colors -> image is generic, not color-accurate */
    var mismatch;
    var ptags = data.tags || [];
    if (ov && ov.forceMismatch === true) mismatch = true;
    else if (ov && ov.forceMismatch === false) mismatch = false;
    else if (ptags.indexOf("kk-photo-differs") !== -1) mismatch = true;
    else if (ptags.indexOf("kk-photo-ok") !== -1) mismatch = false;
    else if (cur && cur.img === false) mismatch = true;
    else mismatch = kkImageIsGeneric(cur, data);
    return { colors:colors, chips:chips, mismatch:mismatch, label:label, isSplit:isSplit, useFallback:!!(ov && ov.useFallback), rawTitle:getCurrentTitle() };
  }

  function renderPill(r){
    var imgArea=document.querySelector(KK_VD.mediaItemSelector) || document.querySelector(KK_VD.imageSelector);
    if(!imgArea) return;
    var pill=document.getElementById("kk-vd-pill");
    if(!pill){ pill=document.createElement("div"); pill.id="kk-vd-pill"; pill.className="kk-vd-pill"; }
    if(pill.parentElement!==imgArea){
      /* (re)anchor to the media item currently shown — variant changes can
         activate a different slide, so the pill follows it. */
      if(getComputedStyle(imgArea).position==="static") imgArea.style.position="relative";
      imgArea.appendChild(pill);
    }
    var nothing = !r.colors.length && !(r.chips&&r.chips.length) && !r.useFallback;
    var hideAccurate = !r.mismatch && KK_VD.showWhenAccurate === false;
    if(nothing || hideAccurate){ pill.style.display="none"; return; }
    pill.style.display=""; pill.innerHTML="";
    pill.classList.toggle("kk-mismatch", !!r.mismatch);
    /* Two-row structure: the photo note gets its OWN row above the colors,
       so the note, slashes, and dots can never run into each other. */
    if(r.mismatch && r.colors.length){
      var note=document.createElement("span"); note.className="kk-photo-note";
      note.textContent="Photo may differ \u2014 you\u2019ll receive:";
      pill.appendChild(note);
    }
    if(!r.colors.length && r.useFallback){
      var span=document.createElement("span"); span.className="kk-fb"; span.textContent="Selected: "+r.rawTitle; pill.appendChild(span); return;
    }
    var row=document.createElement("span"); row.className="kk-vd-row";
    r.colors.forEach(function(c,i){
      var kw=KK_VD.keywords[c]; if(!kw) return;
      if(i>0){ var s=document.createElement("span"); s.className="kk-sep"; s.textContent="/"; row.appendChild(s); }
      var leg=document.createElement("span"); leg.className="kk-leg";
      leg.innerHTML='<span class="kk-dot" style="background:'+kw.hex+';color:'+kw.hex+';"></span>'+esc(kw.name);
      row.appendChild(leg);
    });
    if(r.isSplit){ var sp=document.createElement("span"); sp.className="kk-split"; sp.textContent="SPLIT"; row.appendChild(sp); }
    if(r.chips && r.chips.length){
      var dv=document.createElement("span"); dv.className="kk-lens-divider"; row.appendChild(dv);
      r.chips.forEach(function(ch){
        var chip=document.createElement("span"); chip.className="kk-lens-chip";
        chip.innerHTML='<span class="kk-lens-dot" style="background:'+ch.hex+';"></span>'+esc(ch.text);
        row.appendChild(chip);
      });
    }
    pill.appendChild(row);
  }

  function renderSwatch(r){
    var host=document.getElementById("kk-vd-swatch-host"); if(!host) return;
    var nothing2 = !r.colors.length && !(r.chips&&r.chips.length) && !r.useFallback;
    if(nothing2 || (!r.mismatch && KK_VD.showWhenAccurate === false)){ host.innerHTML=""; return; }
    var splitTag = r.isSplit ? '<span class="kk-sp-split">SPLIT</span>' : "";
    if(r.chips && r.chips.length){
      r.chips.forEach(function(ch){
        splitTag += '<span class="kk-sp-lens"><span class="kk-sp-lens-dot" style="background:'+ch.hex+';"></span>'+esc(ch.text)+'</span>';
      });
    }
    if(!r.colors.length && r.useFallback){
      host.innerHTML = '<div class="kk-vd-swatch"><div class="kk-sp-title"><span>'+esc(r.label)+'</span>'+splitTag+'</div><div class="kk-sp-fb"><b>'+esc(r.rawTitle||"(no variant title)")+'</b><br>this variant differs from the photo shown</div></div>';
      return;
    }
    if(!r.colors.length){
      host.innerHTML = '<div class="kk-vd-swatch"><div class="kk-sp-title" style="margin-bottom:0;"><span>'+esc(r.label)+'</span><span style="display:flex;gap:6px;align-items:center;">'+splitTag+'</span></div></div>';
      return;
    }
    var noteHtml = r.mismatch ? '<div class="kk-sp-note">Product photo may differ \u2014 these are the colors of the variant you selected.</div>' : '';
    var inner = '<div class="kk-vd-swatch'+(r.mismatch?' kk-mismatch':'')+'"><div class="kk-sp-title"><span>'+esc(r.label)+'</span><span style="display:flex;gap:6px;align-items:center;">'+splitTag+'</span></div>'+noteHtml+'<div class="kk-sp-grid">';
    r.colors.forEach(function(c){
      var kw=KK_VD.keywords[c]; if(!kw) return;
      var light=isLight(kw.hex);
      inner += '<div class="kk-sp-item'+(light?" kk-light":"")+'" style="background:'+kw.hex+';"><span class="kk-sp-name">'+esc(kw.name)+'</span></div>';
    });
    inner += '</div></div>';
    host.innerHTML = inner;
  }

  function render(){ var r=resolve(); renderPill(r); renderSwatch(r); }

  function listen(){
    document.addEventListener("change",function(e){
      var t=e.target;
      if(t && t.matches && (t.matches(KK_VD.variantSelector) || t.matches('select[name="id"]') || t.matches('input[name="id"]') || (t.closest && t.closest('form[action*="/cart/add"]')))) {
        setTimeout(render, 50);
      }
    });
    var lastUrl=location.href;
    setInterval(function(){ if(location.href!==lastUrl){ lastUrl=location.href; render(); } }, 500);
  }

  function init(){ listen(); render(); }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",init); else init();
})();
